<template>
	<div class="nav-layout">
		<nav ref="navRef" class="nav-layout__nav-container">
			<NuxtLink :to="localePath('/')">
				<GlobalLogo />
			</NuxtLink>
			<ButtonUnderlined iconBefore="arrow-left" class="nav-layout__button" :to="localePath('/')">{{
				$t('layouts.nav.back_to_homepage')
			}}</ButtonUnderlined>
		</nav>
		<slot />
		<GlobalCallButton />
		<GlobalSmartAppBanner />
	</div>
</template>

<script setup lang="ts">
const navRef = ref<HTMLElement | null>(null)
const navHeight = ref<number | undefined>(undefined)

const localePath = useLocalePath()

onMounted(() => {
	if (navRef.value) {
		const observer = new ResizeObserver((entries) => {
			navHeight.value = entries[0].contentRect.height
		})
		observer.observe(navRef.value)
		onBeforeUnmount(() => observer.disconnect())
	}
})

provide('navHeight', navHeight)
</script>

<style lang="scss" src="./nav.scss"></style>
